export const TCS_REPORT_REQUEST = 'TCS_REPORT_REQUEST';
export const TCS_REPORT_SUCCESS = 'TCS_REPORT_SUCCESS';
export const TCS_REPORT_FAILURE = 'TCS_REPORT_FAILURE';